import {
  ERROR_RECEIVING_CURRENT_USER_PROMOS,
  RECEIVE_CURRENT_USER_PROMOS,
  REQUEST_CURRENT_USER_PROMOS,
} from '../action_constants'

const defaultState = {
  data: [],
  isFetching: false,
  error: null,
}

// We should warp up all user info here regardless of the login status
// TODO: Include device, resolution, etc...
export default function userPromos(state = defaultState, action) {
  switch (action.type) {
    case REQUEST_CURRENT_USER_PROMOS:
      return {
        ...state,
        isFetching: true,
      }
    case RECEIVE_CURRENT_USER_PROMOS:
      return {
        error: null,
        isFetching: false,
        data: action.payload,
      }
    case ERROR_RECEIVING_CURRENT_USER_PROMOS:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      }
    default:
      return state
  }
}
